import { jsx as _jsx } from "react/jsx-runtime";
import { backgroundOption, borderOption, brightOption, fontOption } from "../viewOptionFactory.js";
import { useViewOptions } from "../contexts/viewOptionContext.js";
import { eramTextDimensionMap } from "../../eramFont.js";
export const cpdlcTocSetView = "CPDLC_TOC_SET";
const optionMap = {
    background: backgroundOption(cpdlcTocSetView),
    border: borderOption(cpdlcTocSetView),
    font: fontOption(cpdlcTocSetView),
    bright: brightOption(cpdlcTocSetView),
};
export const initialTocSetOptions = {
    background: true,
    border: true,
    bright: 80,
    font: 2,
};
export const CpdlcTocSet = ({ ViewComponent }) => {
    const viewOptions = useViewOptions();
    const { font } = viewOptions;
    const fontDim = eramTextDimensionMap[font];
    return (_jsx(ViewComponent, { view: cpdlcTocSetView, optionMap: optionMap, width: 50, height: fontDim.height * 10, children: null }));
};
//# sourceMappingURL=CpdlcTocSet.js.map